<template>
  <v-card class="mx-auto mt-n3" flat>
    <v-img :src="`${url}${data.banners?.[0]?.web}`" class="my-3" contain />
    <v-card-title
      class="justify-center text-uppercase page-title"
      :class="{ 'page-titleSm': $vuetify.breakpoint.smAndDown }"
    >
      Chennai Airport
    </v-card-title>

    <v-card-subtitle
      class="text-center page-sub-title"
      :class="{ 'page-subtitleSm': $vuetify.breakpoint.smAndDown }"
    >
      <h1 :class="$vuetify.breakpoint.smAndDown ? 'mt-5' : 'mt-0'">
        {{ data.title }}
      </h1>
    </v-card-subtitle>

    <v-container>
      <v-row
        dense
        v-scrollanimation
        align="center"
        :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
      >
        <v-col
          v-for="(child, i) in data.children"
          :key="i"
          cols="12"
          md="4"
          sm="6"
        >
          <v-card flat class="mr-5" @click="onNavigate(child)">
            <v-hover>
              <div
                slot-scope="{ hover }"
                :class="`${hover ? 'imgover' : 'imgleave'}`"
              >
                <v-img
                  :src="`${url}${child.images[0]?.web?.url}`"
                  class="white--text align-end rounded-xl"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="200px"
                >
                </v-img>
              </div>
            </v-hover>
            <v-card-actions>
              <v-card-title v-text="child.title"></v-card-title>
              <v-spacer></v-spacer>
              <v-btn icon color="#00C6FF">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import config from "../../config";
import event from "../../event";

export default {
  name: "Template-8",
  props: ["data"],
  data() {
    return {
      url: config.airport.url,
    };
  },
  methods: {
    async onNavigate(facility) {
      let url = String(facility.url).toLowerCase().replace(/ /g, "_");
      if (!facility?.children?.length) {
        // if (this.$route.name === "Template")
        //   event.$emit("template", facility._id);
        this.$router.push(url).catch(() => {});
      }
    },
  },
};
</script>
